import { Component } from '@angular/core';
import { AppRoutingModule }     from './app-routing.module';
import { Router } from '@angular/router';
import { User } from '@app/shared';
import { Store } from '@ngrx/store';
//import { routerTransition } from './app-router.transitions';
//import { AppState, selectNotificationState } from '@app/store/app.states';
//import { Store } from '@ngrx/store';
//import { GetPermission } from '@app/store/actions/notification.actions';

import { AppState, selectAuthState } from '@app/store/app.states';
import { MessagingService } from "@app/core/services/messaging.service";
import { UserService }  from '@app/core/services/user.service';
import { SSO } from './store/actions/auth.actions';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
//  animations: [ routerTransition ],
})
export class AppComponent {

  // private getNotificationState$: Observable<any>;
  // private storeNotificationSubscription:Subscription;
  private getAuthState$: Observable<any>;
  private storeAuthSubscription:Subscription;

  private user : User;
  title = 'Promotional Manager';
  // getState(outlet) {
  //   return outlet.isActivated ? outlet.activatedRoute : '';
  // }
  message;
  constructor(
    private msgService : MessagingService,
    private store: Store<AppState>,
    private userService: UserService,
    private router: Router)
    {
    //this.getNotificationState$ = this.store.select(selectNotificationState);
    this.getAuthState$ = this.store.select(selectAuthState);
  //  this.getTeams();
  }

  ngOnInit() {
    this.storeAuthSubscription = this.getAuthState$.subscribe((state) => {

      if(!this.user && state.user){
          this.user = state.user;
          this.msgService.getPermission(this.user);
          this.msgService.init(navigator);
          this.msgService.receiveMessage();
      }
      this.user = state.user;

      if (window.location.href.indexOf('/sso') > -1) {
        this.user = new User();

        let str = window.location.href;
        let str2 = str.substring(str.lastIndexOf('=') + 1);
        this.store.dispatch(new SSO(str2));

        // if(this.userService.isLoggedIn() && this.router.url.indexOf('logout') == -1){
          this.router.navigateByUrl('/main');
        // }
      }
      

    });



    // navigator.serviceWorker.addEventListener('message', function(event) {
    //   console.log('Received a message from service worker: ', event.data);
    // });
  //  this.message = this.msgService.currentMessage;


    // this.storeNotificationSubscription = this.getNotificationState$.subscribe((state) => {
    //   console.log(state.token, ' token');
    // });
    //
    // this.store.dispatch(new GetPermission({}));

  }

  // method to get the teams
  // private getTeams():void{
  //   const payload = {};
  //   this.store.dispatch(new GetTeams(payload));
  // }
  ngOnDestroy():void{
    // unsubscribe;
  //  this.storeNotificationSubscription.unsubscribe();

  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/app.component.ts